(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/pause24/assets/javascripts/pause24.js') >= 0) return;  svs.modules.push('/components/accountservices/pause24/assets/javascripts/pause24.js');

'use strict';

svs.accountservices = svs.accountservices || {};
class Pause24 {
  constructor() {
    this.logger = svs.core.log.getLogger('accountservices:pause24');
  }
  show(callback) {
    const loader = new svs.ui.Loader();
    loader.show(300, 'inverted');
    svs.components.analytics.trackEvent({
      action: 'initiate',
      category: 'spelpaus',
      opt_label: 'spelpaus24'
    });
    this.canSelfExclude((canSelfExclude, activeExclusions) => {
      loader.hide();
      if (canSelfExclude) {
        const dialog = new svs.ui.dialog.Confirm({
          actions: [{
            callback: () => {
              svs.components.analytics.trackEvent({
                action: 'Cancel',
                category: 'spelpaus',
                opt_label: 'Pause24'
              });
              dialog.close();
            },
            title: 'Avbryt'
          }, {
            callback: () => {
              dialog.close();
              this.activateSelfExclusion24(activeExclusions, callback);
            },
            title: 'Aktivera Spelpaus 24'
          }],
          area: svs.ui.dialog.area.POPUP,
          branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
          icon: 'spelpaus',
          message: [{
            align: svs.ui.dialog.message.align.CENTER,
            text: "Pausen g\xE4ller alla spel till ".concat(dateFns.format(dateFns.addDays(new Date(), 1), 'd/M, yyyy'), "."),
            type: svs.ui.dialog.message.TEXT
          }, {
            align: svs.ui.dialog.message.align.CENTER,
            text: 'Pausen upphör automatiskt efter 24 timmar.',
            type: svs.ui.dialog.message.TEXT
          }],
          title: 'Spelpaus24'
        });
        svs.ui.dialog.api.add(dialog);
      } else {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          actions: [{
            title: 'Okej'
          }],
          area: svs.ui.dialog.area.POPUP,
          branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
          icon: 'help-2',
          message: [{
            text: 'Du har aktiva pauser som alla spel som är längre än 24 timmar.'
          }],
          title: 'Vi kunde inte aktivera Spelpaus24'
        }));
      }
    });
  }
  canSelfExclude() {
    let cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
    svs.accountservices.player_exclusions.getActiveExlusions(activeExclusions => {
      const in24h = dateFns.addDays(new Date(), 1);
      if (activeExclusions && activeExclusions.hasTotalPause && dateFns.isAfter(new Date(activeExclusions.alla.expiry), in24h)) {
        cb(false, activeExclusions);
      } else {
        const exclusionsArray = svs.accountservices.player_exclusions.utils.asArray(activeExclusions);
        const longerThenAllowed = exclusionsArray.filter(exclusion => exclusion.expiry && dateFns.isAfter(new Date(exclusion.expiry), in24h));
        cb(longerThenAllowed.length < 5, activeExclusions);
      }
    });
  }
  activateSelfExclusion24(activeExclusions, callback) {
    const loader = new svs.ui.Loader();
    loader.show(300, 'inverted');
    svs.core.jupiter.call({
      method: 'POST',
      path: '/player/1/gamevertical/exclusion24h'
    }, data => {
      const newActiveExclusions = svs.accountservices.player_exclusions.utils.processAPIData(data, activeExclusions);
      svs.components.analytics.trackEvent({
        action: 'Activate',
        category: 'spelpaus',
        opt_label: 'Pause24'
      });
      svs.accountservices.player_exclusions.saveExclusions(newActiveExclusions, () => {
        loader.hide();
        if (typeof callback === 'function') {
          svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
            actions: [{
              title: 'Okej'
            }],
            area: svs.ui.dialog.area.POPUP,
            branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
            icon: 'checkmark-thin',
            message: [{
              align: svs.ui.dialog.message.align.CENTER,
              text: 'Spelpausen gäller alla spel inklusive Poker.',
              type: svs.ui.dialog.message.TEXT
            }, {
              align: svs.ui.dialog.message.align.CENTER,
              text: "Pausen g\xE4ller till ".concat(dateFns.format(dateFns.addDays(new Date(), 1), 'd/M, yyyy'), " och upph\xF6r automatiskt."),
              type: svs.ui.dialog.message.TEXT
            }],
            title: 'Spelpaus24 aktiverad!'
          }));
          callback(newActiveExclusions);
        } else {
          svs.core.flash('info', {
            area: 'popup',
            icon: 'checkmark-thin',
            message: [{
              align: svs.ui.dialog.message.align.CENTER,
              text: 'Spelpausen gäller alla spel inklusive Poker.'
            }, {
              align: svs.ui.dialog.message.align.CENTER,
              text: "Pausen g\xE4ller till ".concat(dateFns.format(dateFns.addDays(new Date(), 1), 'd/M, yyyy'), " och upph\xF6r automatiskt.")
            }],
            title: 'Spelpaus24 aktiverad!'
          }, () => {
            svs.utils.url.navigate(svs.core.urlMapping.get('gamingResponsibilityPause'));
          });
        }
      });
    }, err => {
      loader.hide();
      svs.components.analytics.trackEvent({
        action: 'Cancel',
        category: 'spelpaus',
        opt_label: "Pause24"
      });
      this.logger.error('Error setting Spelpaus 24', err);
      svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
        actions: [{
          title: 'Avbryt'
        }, {
          callback() {
            svs.utils.url.navigate(svs.core.urlMapping.get('customerServiceContact'));
          },
          title: 'Till kundservice'
        }],
        area: svs.ui.dialog.area.POPUP,
        branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
        icon: 'spelpaus',
        message: [{
          text: 'Försök igen eller kontakta vår kundservice.'
        }],
        title: 'Spelpaus24 kunde inte aktiveras'
      }));
    });
  }
}
svs.accountservices.pause24 = new Pause24();

 })(window);